export default __webpack_public_path__ + "static/media/NE.1b87356b.svg";